import React from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import { Box, Inline } from '@styleseat/ui';
import { BodyText } from '../../../ui';
import ExpandableText from '../../../ui/ExpandableText';
import { useIsMobile } from '../../../../hooks';
import { getDescriptionByServiceName } from '../ServiceList/DefaultServices';
import { clickable } from '../../../../styles';

type GalleryImageServiceContentProps = {
  testID?: string;
  blurb: string;
  price: number;
  duration: number;
  serviceName: string;
  onServicePress: () => void;
  onDurationPress: () => void;
  onPricePress: () => void;
  onBlurbPress: () => void;
  onExpandPress: (isExpanded?: boolean) => void;
};

export const GalleryImageServiceContent: React.FCWithChildren<GalleryImageServiceContentProps> = ({
  testID,
  blurb,
  price,
  duration,
  serviceName,
  onServicePress,
  onDurationPress,
  onPricePress,
  onBlurbPress,
  onExpandPress,
}) => {
  const isMobile = useIsMobile();
  const description = blurb || getDescriptionByServiceName(serviceName);
  const hasBlurb = !!description;

  return (
    <Box
      flex={1}
      testID={testID}
      paddingX={!isMobile ? 24 : undefined}
      style={{
        alignSelf: 'center',
        maxWidth: 540,
        width: '100%',
      }}
    >
      <Inline justifyContent="space-between" paddingX={12} paddingY={8}>
        <Inline justifyContent="space-around">
          <TouchableWithoutFeedback onPress={onServicePress}>
            <Box maxWidth={140} style={clickable}>
              <BodyText testID={`${testID}-service`}>{serviceName}</BodyText>
            </Box>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback onPress={onDurationPress}>
            <Box paddingTop={4} testID={`${testID}-duration`} style={clickable}>
              <BodyText weight="thin" appearance="small">{` ${duration} Mins`}</BodyText>
            </Box>
          </TouchableWithoutFeedback>
        </Inline>
        <TouchableWithoutFeedback onPress={onPricePress}>
          <BodyText weight="bold" testID={`${testID}-price`} style={clickable}>${price}</BodyText>
        </TouchableWithoutFeedback>
      </Inline>
      <Box paddingX={12}>
        {hasBlurb && (
          <TouchableWithoutFeedback onPress={onBlurbPress}>
            <Box paddingBottom={8} testID={`${testID}-blurb`} style={clickable}>
              <ExpandableText
                text={description}
                maxLength={isMobile ? 150 : 65}
                onPress={onExpandPress}
              />
            </Box>
          </TouchableWithoutFeedback>
        )}
      </Box>
    </Box>
  );
};

export default GalleryImageServiceContent;
